import React from 'react'
import Nav from './Nav'

export default () => (
  <header style={{ marginBottom: '1em' }}>
    <h1 className="heading is-size-3">Activity Tracker</h1>
    <Nav />
  </header>
)
